// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.oZ5nu {
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    pointer-events: none;
    overflow: hidden;
    z-index: 100;
}

.hpVot {
    position: absolute;
    bottom: 0;
    animation: K2EyT 0.6s ease-out forwards, mWqtN 0.5s ease-out 0.6s forwards;
}

.iB4k3 {
    position: absolute;
    border-radius: 50%;
    transform-origin: center;
    animation: O37jd 0.7s ease-out 0.6s forwards;
    opacity: 0;
}

.koLkA {
    position: absolute;
    border-radius: 50%;
    animation: KL_EM 0.8s ease-in-out forwards;
    opacity: 0;
}

@keyframes K2EyT {
    0% {
        transform: translateY(0);
        opacity: 1;
    }
    100% {
        transform: translateY(-50vh);
        opacity: 1;
    }
}

@keyframes mWqtN {
    0% {
        opacity: 1;
    }
    100% {
        opacity: 0;
    }
}

@keyframes O37jd {
    0% {
        opacity: 1;
        transform: translateY(0) rotate(var(--rotation)) scale(1);
    }
    100% {
        opacity: 0;
        transform: translateY(-100px) rotate(var(--rotation)) scale(0.5);
    }
}

@keyframes KL_EM {
    0% {
        opacity: 0;
        transform: scale(0);
    }
    50% {
        opacity: 1;
        transform: scale(1);
    }
    100% {
        opacity: 0;
        transform: scale(0);
    }
}
`, "",{"version":3,"sources":["webpack://./src/components/fireworks/Fireworks.css"],"names":[],"mappings":"AAAA;IACI,kBAAkB;IAClB,MAAM;IACN,OAAO;IACP,QAAQ;IACR,SAAS;IACT,oBAAoB;IACpB,gBAAgB;IAChB,YAAY;AAChB;;AAEA;IACI,kBAAkB;IAClB,SAAS;IACT,0EAA6F;AACjG;;AAEA;IACI,kBAAkB;IAClB,kBAAkB;IAClB,wBAAwB;IACxB,4CAAqD;IACrD,UAAU;AACd;;AAEA;IACI,kBAAkB;IAClB,kBAAkB;IAClB,0CAAgD;IAChD,UAAU;AACd;;AAEA;IACI;QACI,wBAAwB;QACxB,UAAU;IACd;IACA;QACI,4BAA4B;QAC5B,UAAU;IACd;AACJ;;AAEA;IACI;QACI,UAAU;IACd;IACA;QACI,UAAU;IACd;AACJ;;AAEA;IACI;QACI,UAAU;QACV,yDAAyD;IAC7D;IACA;QACI,UAAU;QACV,gEAAgE;IACpE;AACJ;;AAEA;IACI;QACI,UAAU;QACV,mBAAmB;IACvB;IACA;QACI,UAAU;QACV,mBAAmB;IACvB;IACA;QACI,UAAU;QACV,mBAAmB;IACvB;AACJ","sourcesContent":[".container {\n    position: absolute;\n    top: 0;\n    left: 0;\n    right: 0;\n    bottom: 0;\n    pointer-events: none;\n    overflow: hidden;\n    z-index: 100;\n}\n\n.firework {\n    position: absolute;\n    bottom: 0;\n    animation: launchFirework 0.6s ease-out forwards, explodeFirework 0.5s ease-out 0.6s forwards;\n}\n\n.particle {\n    position: absolute;\n    border-radius: 50%;\n    transform-origin: center;\n    animation: expandParticle 0.7s ease-out 0.6s forwards;\n    opacity: 0;\n}\n\n.sparkle {\n    position: absolute;\n    border-radius: 50%;\n    animation: sparkleAnim 0.8s ease-in-out forwards;\n    opacity: 0;\n}\n\n@keyframes launchFirework {\n    0% {\n        transform: translateY(0);\n        opacity: 1;\n    }\n    100% {\n        transform: translateY(-50vh);\n        opacity: 1;\n    }\n}\n\n@keyframes explodeFirework {\n    0% {\n        opacity: 1;\n    }\n    100% {\n        opacity: 0;\n    }\n}\n\n@keyframes expandParticle {\n    0% {\n        opacity: 1;\n        transform: translateY(0) rotate(var(--rotation)) scale(1);\n    }\n    100% {\n        opacity: 0;\n        transform: translateY(-100px) rotate(var(--rotation)) scale(0.5);\n    }\n}\n\n@keyframes sparkleAnim {\n    0% {\n        opacity: 0;\n        transform: scale(0);\n    }\n    50% {\n        opacity: 1;\n        transform: scale(1);\n    }\n    100% {\n        opacity: 0;\n        transform: scale(0);\n    }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"container": `oZ5nu`,
	"firework": `hpVot`,
	"launchFirework": `K2EyT`,
	"explodeFirework": `mWqtN`,
	"particle": `iB4k3`,
	"expandParticle": `O37jd`,
	"sparkle": `koLkA`,
	"sparkleAnim": `KL_EM`
};
export default ___CSS_LOADER_EXPORT___;
